function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "B8C88E7D-1A96-4B04-95D6-98E13C690808@1.00x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-64.000000, -992.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "list-all",
  transform: "translate(64.000000, 992.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "symbol",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.5,16 C21.7761424,16 22,16.2238576 22,16.5 L22,19.5 C22,19.7761424 21.7761424,20 21.5,20 L8.5,20 C8.22385763,20 8,19.7761424 8,19.5 L8,16.5 C8,16.2238576 8.22385763,16 8.5,16 L21.5,16 Z M5.5,16 C5.77614237,16 6,16.2238576 6,16.5 L6,19.5 C6,19.7761424 5.77614237,20 5.5,20 L2.5,20 C2.22385763,20 2,19.7761424 2,19.5 L2,16.5 C2,16.2238576 2.22385763,16 2.5,16 L5.5,16 Z M21.5,10 C21.7761424,10 22,10.2238576 22,10.5 L22,13.5 C22,13.7761424 21.7761424,14 21.5,14 L8.5,14 C8.22385763,14 8,13.7761424 8,13.5 L8,10.5 C8,10.2238576 8.22385763,10 8.5,10 L21.5,10 Z M5.5,10 C5.77614237,10 6,10.2238576 6,10.5 L6,13.5 C6,13.7761424 5.77614237,14 5.5,14 L2.5,14 C2.22385763,14 2,13.7761424 2,13.5 L2,10.5 C2,10.2238576 2.22385763,10 2.5,10 L5.5,10 Z M21.5,4 C21.7761424,4 22,4.22385763 22,4.5 L22,7.5 C22,7.77614237 21.7761424,8 21.5,8 L8.5,8 C8.22385763,8 8,7.77614237 8,7.5 L8,4.5 C8,4.22385763 8.22385763,4 8.5,4 L21.5,4 Z M5.5,4 C5.77614237,4 6,4.22385763 6,4.5 L6,7.5 C6,7.77614237 5.77614237,8 5.5,8 L2.5,8 C2.22385763,8 2,7.77614237 2,7.5 L2,4.5 C2,4.22385763 2.22385763,4 2.5,4 L5.5,4 Z"
})))));

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.5241aedb.svg";
export { ForwardRef as ReactComponent };